<script>

import { useToast } from "vue-toastification";

var sha512 = require('js-sha512');

import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { savePass, getUser, getUserPassData, unlockUser, generatePass } from '@/services/serviceUser';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'UserPswd',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,LoadingButton
		,Alert
	},
	props: {'userId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["userId","changeRecord"],
	data() {
		return {
			metaData: [],
			
			isLoading:true,
			isSending:false,
			
			data:[],
			user:[]
		}
	},
	
	mounted:function(){

	},
	
	methods: {
		// load data form
		loadDefaultValues:function(){
			
			this.isLoading=true

			getUserPassData().then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;

				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});

			getUser({userId:this.userId}).then(response => {
				if(!response.statusText){
					this.user = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},
		
		onClose:function(){
			if(this.userId!='null'){
				unlockUser({userId:this.userId}).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},
		
		onSave:function(){
							
			if(this.checkPasswordV2()){

				this.isSending=true;
				
				savePass({p:sha512(this.data.password),userId:this.userId}).then(response => {
					if(!response.statusText){
						this.isSending=false
						if(response.resCode==1){
							this.toast.success(this.$t('msgCore.dataWasSaved'));
							this.$emit('changeRecord', '')
							this.data = [];
							this.user = [];
							this.modalObject.hide();
						}else if(response.resCode==0){
							this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
						}else if(response.resCode==2){
							this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
						}else if(response.resCode==3){
							this.toast.error(this.$t('msgCore.accessDenied'));
						}
					}else{
						this.isSending=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
				
			}
			
		},
		
			
		checkPasswordV2:function()
		{
			if(this.data.password){

				//1.
				if(this.data.password.length < 6){
					this.data.passwordError = true;
					this.toast.error(this.$t('msgCore.passwordIsTooShort'));
					return false;
				}
				
				//2.
				var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/; 
				if (!re.test(this.data.password)) {
					this.data.passwordError = true;	
					this.toast.error(this.$t('msgCore.passwordMustHaveSmallBigLettersAndNumbers'));
					return false;
				}
				
				//3.
				if (this.data.password != this.data.passwordRepeat){
					this.data.passwordError = true;		
					this.data.passwordRepeatError = true;	
					this.toast.error(this.$t('msgCore.passwordsDoNotMatch'));
					return false;
				}
				
				this.data.passwordError = false;
				this.data.passwordRepeatError = false;
				return true;

			}else{
				return false;
			}

		},
		
		//generuje nahodne heslo
		onGeneratePass:function(){
			
			this.isSending=true;
			generatePass().then(response => {
				
				if(!response.statusText){
					this.data.password = response.newPswd; 
					this.data.passwordRepeat = response.newPswd;
					this.checkPasswordV2();
					this.isSending=false;
				}else{
					this.isSending=false;
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});
		
		},
		
		//zobrazi heslo
		showPswd: function(){
			this.data.showInput = this.data.showInput===true?false:true;
		}
		
	},
	
	watch: {
		userId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.User') }} <b><span>{{ user.name }} {{ user.surname }}</span></b></h6>
				</div>
		
				<div v-if="metaData.modulAccess && (auth.usersChangePasswd)" class="modal-body">
				
					<div class="row">
						<div class="col-12">
							<p>{{$t('msgCore.setPassword')}} 
								<LoadingButton :isDisabled="(!auth.usersChangePasswd || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onGeneratePass" :label="'msgCore.GeneratePassword'" color="success"></LoadingButton>
							</p>
						</div>	
					</div>
					
					<div class="row">
						
						<div class="col-md-6 col-12">
							<div class="input-group">
								<input :type="data.showInput ? 'text' : 'password'" autocomplete="new-password" v-on:change="checkPasswordV2()" class="form-control form-control-sm" :class="{'is-invalid':data.passwordError}" v-model="data.password" :placeholder="$t('msgCore.Password')" >
								<button type="button" class="btn btn-outline-info btn-sm my-btn" v-on:click="showPswd()">
									<i v-if="!data.showInput" :title="$t('msgCore.showPassword')" class="smire-icon far fa-eye"></i>
									<i v-else :title="$t('msgCore.hidePassword')" class="smire-icon far fa-eye-slash"></i>
								</button>
							</div>
							<div v-show="data.passwordError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
						</div>
						
						<div class="col-md-6 col-12">
							<div class="input-group">
								<input :type="data.showInput ? 'text' : 'password'" autocomplete="new-password" v-on:change="checkPasswordV2()" class="form-control form-control-sm" :class="{'is-invalid':data.passwordRepeatError}" v-model="data.passwordRepeat" :placeholder="$t('msgCore.passwordRepeat')" >
								<button type="button"  class="btn btn-outline-info btn-sm my-btn" v-on:click="showPswd()">
									<i v-if="!data.showInput" :title="$t('msgCore.showPassword')" class="smire-icon far fa-eye"></i>
									<i v-else :title="$t('msgCore.hidePassword')" class="smire-icon far fa-eye-slash"></i>
								</button>								
							</div>
							<div v-show="data.passwordRepeatError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
						</div>	
					</div>	
					
				</div>
				
				<div v-else class="modal-body">
					<div class="row">
						<div class="col-12 mt-3">
							<Alert type="warning" :label="$t('msgCore.accessDenied')" />
						</div>
					</div>
				</div>
				
				<div class="modal-footer">
				
					<div class="btn-group">
						<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
						
						
						<LoadingButton :isDisabled="(!auth.usersChangePasswd || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>
					</div>	
					
				</div>
				
			</div>

		</div>
		
	</div>
</div>
		
</template>


